<template>
  <div class="page zntjMd" v-loading='waiting'>
    <div class="page-header">
      <div class="page-title"><span>种子客户数：<i style="color:#5088FF;font-size:13px">{{companyNum}}</i> 个 <i style="display:none">，已解锁 {{unLockCompanyNum}} 个</i></span></div>
      <div class="page-header-action">
        <!-- <el-tooltip class="item" effect="dark" content="添加成交用户按钮：在弹窗里添加已成交的客户数据，我们将根据您添加并提交的数据为您推荐相似企业" placement="bottom">
          <i class="el-icon-question"></i>
        </el-tooltip>
        <el-button @click="openDialog" type="plain">添加成交用户</el-button> -->
        <el-button @click="openDialog" type="dialog-confirm" size="small">种子客户</el-button>
      </div>
    </div>
    <div class="intelBox">
      <div class="detail-title">
        <div class="font-15-md">
          <em>小T为您找到 <span class="blueColor" style="color: #5088FF;">{{_totalElements}}</span> 家企业</em>
          <span class="ml-20">
          </span>
        </div>
        <div class="setCheckBox gbBatchUnlock">
          <span class="choiceNum" v-if="selectNum>0">已勾选{{selectNum}}个</span>
          <el-button :loading="actionLoading" v-interestExpire type="info" plain size="small" @click="batchUnlockFn">批量解锁</el-button>
          <!-- <slot name="beforeBatch"></slot> -->
          <el-button :loading="actionLoading1" type="info" plain size="small" @click="batchStarFn">收藏</el-button>
        </div>
        <div class="detail-title-action">
        </div>
      </div>
      <div class="detail">
        <div class="companyHead">
          <div class="compHDLeft">
            <el-checkbox style="margin-right:50px" :indeterminate="isIndeterminate" v-model="checkAll" @change="selectAllFnG"></el-checkbox>
            <span class="headTitle headInfo">企业信息</span>
          </div>
          <span class="headTitle headMay">联系方式</span>
        </div>
        <company-card :companyType="6" class="companyCard" v-for="(companyCard, index) in companyCards" @unlock-change="handleUnlockChange(index)" :key="`${(companyCard || {}).id || ''}${index}`"
          :baseData="companyCard" :xiaoT="true" @change-recommendList="recommendListNew">
          <el-checkbox class="checkBoxes" v-if="true && companyCards.length>0" v-model="checkList[index].checked" @click.native.stop="" @change="selectSingleFnG"></el-checkbox>
        </company-card>
        <EmptyBox v-if="!companyCards.length" :src="require('@/assets/newicons/i002.png')" />
        <Pagination :pageNum="list.pageNum" :pageSize="list.pageSize" :total="list.total" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange" />
      </div>
    </div>
    <newRecommendDialog v-if="showRecommendDialog" ref="recommendDialog" v-model="showRecommendDialog" @change="recommendChange"></newRecommendDialog>
    <unlock-dialog :show.sync="unlockDialogShow" :list="companyList" :usedTotalDialogP="usedTotalDialog" title="批量解锁" :confirmPromise="contactsNumBatchConfirm"></unlock-dialog>
    <robot />

    <!-- 批量解锁提示 -->
    <batch-unlock-tip ref="batchUnlockTip"></batch-unlock-tip>
    <right-float ref="rightFloat" :globalRfType="true"></right-float>
  </div>
</template>

<script>
import Pagination from '@/components/pagination'
import newRecommendDialog from '@/components/newRecommendDialog'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { recommendListNew, batchStar, contactsNumBatchV2, unlockContacts } from '../api/newClueApi'
import { getTransactionCompanyNum } from '../api/index'
import companyCard from '../components/companyCard'
import unlockDialog from '../components/unlockDialog'
import Robot from '../components/robot'
import { cueQuotaStatistics } from '@/views/home/api'
import CompanyCardList from '../components/companyCardList'
import batchUnlockTip from '@/components/batchUnlockTip'
import RightFloat from '@/components/rightFloatBtn'
export default {
  name: 'intelRecommend',
  provide() {
    return {
      unlockSourceType: 6
    }
  },
  components: {
    companyCard,
    newRecommendDialog,
    unlockDialog,
    Robot,
    CompanyCardList,
    batchUnlockTip,
    RightFloat,
    Pagination
  },
  data() {
    return {
      companyNum: 0,
      unLockCompanyNum: 0,
      companyCards: [],
      showRecommendDialog: false,
      showSetCheckBox: [false, false], // 0.批量解锁   1.批量收藏
      // checkBoxType: [false, false],
      actionLoading: false,
      actionLoading1: false,
      checkList: [],
      waiting: false,
      companyList: [],
      unlockDialogShow: false,
      batchunlockShow: true,
      recommendListTimer: null,
      usedTotalDialog: 0,
      checkAll: false,
      selectNum: 0,//动态选中个数
      isIndeterminate: false,
      list: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        // tab: 1,
        // tableData: []
      }
    }
  },
  computed: {
    ...mapState({
      surplus: state => state.user.surplus
    }),
    selectAll() {
      const arr = this.checkList.filter(e => e.checked === false)
      return arr.length
    },
    checkBoxShow() {
      return this.showSetCheckBox.some(v => v)
    },
    allTotal() {
      return this.list.total
    },
    _totalElements() {
      if (this.allTotal < 100) return this.allTotal
      if (this.allTotal < 200000) return `${this.allTotal.toString().split('').reduce((res, v) => res ? res + 0 : v, '')}+`
      return '200000+'
    },
  },
  watch: {
    surplus: {
      immediate: true,
      handler: function (val, oldVal) {
        if (val < 1) {
          this.showCheckBox(false)
          this.batchunlockShow = false
        } else {
          this.batchunlockShow = true
        }
      }
    }
  },
  mounted() {
    this.recommendListNew()
    this.getTransactionCompanyNum()
  },
  methods: {
    recommendChange() {
      this.recommendListNew()
      this.getTransactionCompanyNum()
    },
    selectSingleFnG(val) {
      this.selectNum = this.checkList.filter(e => (e.checked)).length
      if (this.selectNum == this.checkList.length) {
        this.checkAll = true
        this.isIndeterminate = false
      } else {
        this.checkAll = false
        if (0 < this.selectNum < this.checkList.length) {
          this.isIndeterminate = true
        }
        if (this.selectNum == 0) {
          this.isIndeterminate = false
        }
      }

    },
    selectAllFnG(val) {
      if (val) {
        this.checkList.forEach(e => { e.checked = true })
        this.selectNum = this.checkList.length
        this.isIndeterminate = false
      } else {
        this.selectNum = 0
        this.checkList = []
        if (this.companyCards) {
          this.companyCards.forEach(e => {
            this.checkList.push({ companyName: e.name, hid: e.hid, checked: false, star: e.star, unlock: e.unlock })
          })
        }
      }
    },
    getTransactionCompanyNum() {
      getTransactionCompanyNum().then(res => {
        this.companyNum = res.data.companyNum || 0
        this.unLockCompanyNum = res.data.unLockCompanyNum || 0
      })
    },
    removeHtml(str) {
      if (!str) return
      const reTag = /<(?:.|\s)*?>/g
      return str.replace(reTag, '').replace(/&nbsp;/ig, '')
    },
    companyNames() {
      return this.checkList.filter(e => (e.checked && !e.star)).map(e => {
        // type 1 标准资源
        return { name: this.removeHtml(e.companyName), hid: e.hid, type: 2, similarValue: e.similarValue || null, similarity: e.similarity || null }
      })
    },
    handleUnlockChange(index) {
      this.companyCards[index].checked = true
      this.cancalAllFn()
    },
    selectAllFn() {
      this.checkList.forEach(e => { e.checked = true })
    },
    cancalAllFn() {
      this.isIndeterminate = false
      this.selectNum = 0
      this.checkAll = false
      this.checkList = []
      this.companyCards.forEach(e => {
        // this.checkList.push({ companyName: e.name, hid:e.hid,checked: false, star: e.star, unlock: e.unlock })
        this.checkList.push({ companyName: e.name, hid: e.hid, checked: false, star: e.star, unlock: e.unlock, similarValue: e.similarValue || null, similarity: e.similarity || null })
      })
    },
    showCheckBox(type) {
      // this.checkBoxType = type
      if (type || type === 0) {
        this.showSetCheckBox[type] = !this.showSetCheckBox[type]
        const arr = [false, false]
        arr[type] = this.showSetCheckBox[type]
        this.showSetCheckBox = arr
      } else {
        this.showSetCheckBox = [false, false]
      }
      this.checkList.length = 0
      this.companyCards.forEach(e => {
        this.checkList.push({ companyName: e.name, hid: e.hid, checked: false, star: e.star, unlock: e.unlock, similarValue: e.similarValue || null, similarity: e.similarity || null })
      })
    },
    batchUnlockFn() {
      if (this.checkList.filter(e => e.checked).length) {
        this.contactsNumBatchV2(this.checkList.filter(e => (e.checked && !e.unlock)).map(e => {
          const obj = { companyName: this.removeHtml(e.companyName), hid: e.hid }
          if (e.similarValue) obj.similarValue = e.similarValue
          if (e.similarity) obj.similarity = e.similarity
          return obj
        }))
      } else {
        this.$message.warning('还未选择企业')
      }
    },
    getcueQuotaStatistics() {
      cueQuotaStatistics().then(res => {
        if (res.code == 200) {
          this.usedTotalDialog = res.data.companyInterest.usedTotal
        }
      })
    },
    contactsNumBatchV2(companyList) {
      if (companyList.length) {
        // 重新获取解锁数据
        // this.$store.commit('SET_FREQUENCY', this.$store.state.user.frequency + 1)
        this.getcueQuotaStatistics()
        this.unlockDialogShow = true
        this.companyList = companyList
        // try {
        //   this.actionLoading = true
        //   this.checkList = this.checkList.map(e => ({ ...e, checked: false }))
        //   await contactsNumBatchV2({ list: companyList })
        //   this.actionLoading = false
        //   this.$message.success('解锁成功')
        //   this.companyCards.forEach(e => {
        //     if (companyList.find(ee => (ee.name || ee.companyName) === this.removeHtml(e.name || e.companyName))) {
        //       e.unlock = true
        //     }
        //   })
        // } catch (error) {
        //   console.dir(error)
        //   this.actionLoading = false
        // }
      } else {
        this.$message.warning('已经解锁过了')
      }
    },
    contactsNumBatchConfirm() {
      return new Promise((resolve, reject) => {
        this.actionLoading = true
        contactsNumBatchV2({ list: this.companyList }).then(res => {
          this.actionLoading = false
          const { code, data = [], message } = res
          if (code == 200) {
            resolve()
            this.$message.success('解锁成功')
            this.companyCards.forEach(e => {
              const name = this.removeHtml(e.name || e.companyName)
              if (this.companyList.find(ee => (ee.name || ee.companyName) === name) && data[0].succeededHids.indexOf(e.hid) != -1) {  // data 返回的是hid数组
                e.unlock = true
                unlockContacts({ hids: data[0].succeededHids }).then(rs => {
                  if (rs.code == 200) {
                    e.contactListVOS = rs.data[e.hid]
                  }
                })
              }
            })
            this.resetCheckList()
            this.selectNum = 0
            this.$refs.batchUnlockTip.getUnlockBatchTip()
            this.$refs.batchUnlockTip.tipTitleF('1')
          } else {
            reject()
            this.$message.error(message)
          }
        }).catch((error) => {
          // this.$message.error(error.message)
          reject()
          this.actionLoading = false
        })
      })
    },
    batchStarFn() {
      if (this.checkList.filter(e => e.checked).length) {
        this.batchStar(this.companyNames())
      } else {
        this.$message.warning('还未选择企业')
      }
    },
    openDialog() {
      this.showRecommendDialog = true
    },

    async batchStar(companyList) {
      if (companyList.length) {
        try {
          this.actionLoading1 = true
          // this.checkList = this.checkList.map(e => ({ ...e, checked: false }))
          await batchStar({ companyList })
          this.actionLoading1 = false
          this.$message.success('收藏成功')
          this.companyCards.forEach(e => {
            if (companyList.find(ee => (ee.name || ee.companyName) === this.removeHtml(e.name || e.companyName))) {
              e.star = true
            }
          })
          // this.resetCheckList()
          this.cancalAllFn()
        } catch (error) {
          this.actionLoading1 = false
        }
      } else {
        this.$message.warning('已经收藏过了')
      }
    },

    resetCheckList() {
      this.checkList = this.companyCards.map(e => {
        return { companyName: e.name, hid: e.hid, checked: false, star: e.star, unlock: e.unlock, similarValue: e.similarValue || null, similarity: e.similarity || null }
      })
      this.checkAll = false
    },
    handleSizeChange(pageSize) {
      this.list.pageNum = 1
      this.list.pageSize = pageSize
      this.recommendListNew()
    },
    handleCurrentChange(pageNum) {
      this.list.pageNum = pageNum
      this.recommendListNew()
    },
    async recommendListNew() {
      this.cancalAllFn()
      this.waiting = true
      try {
        const res = await recommendListNew({
          pageNum: this.list.pageNum,
          pageSize: this.list.pageSize,
        })
        // 判断没有数据就接着调用
        // if (!data.length) {
        //   this.recommendListTimer = setTimeout(() => {
        //     this.recommendListNew()
        //   }, 2000)
        //   return
        // }
        // 有数据了展示
        // this.recommendListTimer && clearTimeout(this.recommendListTimer)
        // this.recommendListTimer = null
        this.companyCards = res?.data?.list || []

        this.list.total = res?.data?.total

        this.resetCheckList()
        // 统一数据格式
        this.companyCards.forEach(e => {
          if (!e.hasOwnProperty('unlock')) {
            this.$set(e, 'unlock', false)
          }
          if (!e.hasOwnProperty('star')) {
            this.$set(e, 'star', false)
          }
        })
        this.waiting = false
      } catch (error) {
        console.log(error)
        this.waiting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  margin: 0 auto;
  // width: 1100px;
}

.page-header {
  height: 70px;
  display: flex;
  padding: 0 24px;
  align-items: center;
  // background-color: white;

  background: #ffffff;
  box-shadow: 0px 1px 5px 0px rgba(38, 38, 38, 0.1);
  border-radius: 4px;
  .page-title {
    // color: #409eff;
    font-size: 16px;
    span {
      font-size: 13px;
    }
  }
  &-action {
    margin-left: auto;
    display: flex;
    align-items: center;
    i {
      cursor: pointer;
      font-size: 18px;
      margin-right: 12px;
      color: #409eff;
    }
  }
}
.detail {
  // padding: 0 120px;
  padding: 0;
}
.detail-title {
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0 24px;
  // width: calc(100% - 240px);
  margin: 0 auto;
  background: #fafafd;
  border-radius: 4px 4px 0px 0px;
  &-action {
    margin-left: auto;
    display: flex;
    align-items: center;

    .change-action {
      margin-left: 24px;
      cursor: pointer;
      color: #5088ff;
      img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
        animation: none;
        -webkit-animation: none;
        -ms-animation: none;
        -moz-animation: none;
        -webkit-animation: none;
        -o-animation: none;
        vertical-align: sub;
      }
      &:hover {
        color: #0072ff;
      }
      &:hover img {
        animation: changeRotate 1s linear infinite;
        -webkit-animation: changeRotate 1s linear infinite;
        -ms-animation: changeRotate 1s linear infinite;
        -moz-animation: changeRotate 1s linear infinite;
        -webkit-animation: changeRotate 1s linear infinite;
        -o-animation: changeRotate 1s linear infinite;
      }
    }
  }
}

.setCheckBox {
  text-align: center;
  height: 60px;
  background-color: #f3f9ff;
  line-height: 60px;
  border-bottom: 2px solid #f0f2f5;
  /deep/ .el-button {
    padding: 0;
    width: 100px;
    height: 36px;
    margin-left: 30px;
    > span {
      font-size: 14px;
    }
    &:nth-of-type(1) {
      margin-left: 0;
      color: #333333;
      background: rgba(255, 255, 255, 0.2);
      box-shadow: 0px 2px 4px 0px #edeef3;
      border-radius: 4px;
      border: 1px solid #bbbeca;
    }
  }
}

.intelBox {
  background-color: white;
  margin-top: 16px;
  margin-bottom: 24px;
  box-shadow: 0px 1px 5px 0px rgba(38, 38, 38, 0.1);
}

@keyframes changeRotate {
  0% {
    transform: rotateZ(0deg);
    -ms-transform: rotateZ(0deg);
    -moz-transform: rotateZ(0deg);
    -webkit-transform: rotateZ(0deg);
    -o-transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
    -ms-transform: rotateZ(360deg);
    -moz-transform: rotateZ(360deg);
    -webkit-transform: rotateZ(360deg);
    -o-transform: rotateZ(360deg);
  }
}
.checkBoxes {
  position: relative;
  // width: 30px;
  margin-right: 50px;
}
.page-header {
  .page-header-action {
    .el-button--dialog-confirm {
      width: 100px;
      height: 36px;
      padding: 0;
    }
  }
}
.zntjMd {
  .setCheckBox {
    text-align: center;
    height: 72px;
    background: rgba(187, 190, 202, 0.3);
    line-height: 72px;
    border-bottom: none;
  }
}
.font-16-md {
  font-size: 16px;
  font-weight: 600;
  color: rgba(52, 57, 81, 0.7);
}
.font-15-md {
  font-size: 15px;
  font-weight: 600;
  color: rgba(52, 57, 81, 0.7);
}
::v-deep {
  .detail-title-action {
    .el-button + .el-button {
      margin-left: 24px;
    }
    .el-button {
      span {
        font-size: 14px;
      }
    }
    .change-action {
      font-size: 14px;
      margin-top: -1px;
    }

    .el-button {
      i {
        margin-right: 4px;
        &::before {
          content: "";
          width: 20px;
          height: 20px;
          display: inline-block;
          vertical-align: -5px;
        }
      }
    }
    .icon-shoucang1xiao {
      &::before {
        background-image: url("~@/assets/gbIcon/xx.svg");
      }
    }
    .icon-jiesuo {
      &::before {
        background-image: url("~@/assets/gbIcon/unlocking.svg");
      }
    }
  }
}
.companyHead {
  display: flex;
  height: 52px;
  line-height: 52px;
  background: #f5f6f8;
  padding: 0 0px 0 32px;
  box-sizing: border-box;
  justify-content: space-between;
  .compHDLeft {
    //  width: 81%;
  }
  span {
    font-weight: 600;
    color: #343951;
    font-size: 14px;
    display: inline-block;
    &.headInfo {
      // width: 61%;
    }
    &.headMay {
      width: 20.09%;
      box-sizing: border-box;
    }
  }
}

.setCheckBox.gbBatchUnlock {
  background: none;
  height: auto;
  line-height: normal;
  margin-left: 8px;
  padding-left: 8px;
  position: relative;
  &::before {
    position: absolute;
    content: "";
    display: block;
    width: 1px;
    height: 18px;
    background: #efefef;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
  }
  .el-button {
    color: #333333;
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0px 2px 4px 0px #edeef3;
    border-radius: 4px;
    border: 1px solid #bbbeca;
    margin-left: 8px;
  }
  .choiceNum {
    margin-right: 46px;
    font-weight: 600;
    color: #343951;
    font-size: 16px;
  }
}
</style>
